import styled from '@emotion/styled';
import React from 'react';
import { Github } from '../../assets';
import { Box, Typography } from '@mui/material';
import packageJson from '../../../package.json';

interface SidebarFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  collapsed?: boolean;
}

const StyledButton = styled.a`
  padding: 5px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: inline-block;
  background-color: #fff;
  color: #484848;
  text-decoration: none;
`;

const StyledSidebarFooter = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 8px;
  color: white;
  background: linear-gradient(45deg, rgb(21 87 205) 0%, rgb(90 225 255) 100%);
  /* background: #0098e5; */
`;

const StyledCollapsedSidebarFooter = styled.a`
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  color: white;
  background: linear-gradient(45deg, rgb(21 87 205) 0%, rgb(90 225 255) 100%);
  /* background: #0098e5; */
`;

const codeUrl =
  'https://github.com/AliSajadian/react-typescript-redux-mui/blob/master/src';

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ collapsed, ...rest }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '20px',
        marginTop: '32px',
      }}
    >
      {collapsed ? (
        <StyledCollapsedSidebarFooter href={codeUrl} target="_blank">
            <Github size={28} />
        </StyledCollapsedSidebarFooter>
      ) : (
        <StyledSidebarFooter {...rest}>
          <Box sx={{ marginBottom: '12px' }}>
            <Github size={30} />
          </Box>
          <Typography fontWeight={600} sx={{ fontSize:'11pt' }}>Pro Template</Typography>
          <Typography variant="caption" sx={{ letterSpacing: 1, opacity: 0.7 }}>
            V {packageJson.version}
          </Typography>
          <Box sx={{ marginTop: '16px' }}>
            <StyledButton href={codeUrl} target="_blank">
              <Typography variant="caption" color="#607489" fontWeight={600}>
                View code
              </Typography>
            </StyledButton>
          </Box>
        </StyledSidebarFooter>
      )}
    </Box>
  );
};
